import React, { Component } from "react";
import { connect } from "react-redux";

import Showroom from "components/Showroom";
import Loading from "components/Loading";
import "./Main.css";

import { actions as showroomActions } from "reducers/main/showroom";
import { status as showroomStatus } from "reducers/main/showroom";

class Main extends Component {
  componentWillMount() {
    let currentShowroom = this.props.match.params.showroom;
    this.props.getShowroomInfo(currentShowroom);
  }

  render() {
    let { showroom } = this.props;
    let { handleProductSelect } = this.props;
    if (showroom != null &&  showroom.showroom != null){
      document.title = showroom.showroom.name
      ? "LIXIL | ショールーム | " + showroom.showroom.name + " | 展示品写真"
      : document.title;
    }
    return (
      <div>
        {showroom.status === showroomStatus.SUCCESS ? (
          <Showroom
            showroom={showroom}
            handleProductSelect={handleProductSelect}
          />
        ) : (
          <Loading />
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  showroom: state.main.showroom
});

const mapDispatchToProps = {
  handleProductSelect: showroomActions.setCurrentProductId,
  getShowroomInfo: showroomActions.getAsync
};

export default connect(mapStateToProps, mapDispatchToProps)(Main);



// WEBPACK FOOTER //
// ./src/pages/Main/Main.js